"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomService = exports.CustomServiceCreatorRoleEnum = void 0;
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const typeorm_1 = require("typeorm");
const contact_profile_enum_1 = require("./contact-profile-enum");
const invoicing_target_1 = require("./invoicing-target");
const job_1 = require("./job");
const job_selection_1 = require("./job-selection");
var CustomServiceCreatorRoleEnum;
(function (CustomServiceCreatorRoleEnum) {
    CustomServiceCreatorRoleEnum["ADMIN"] = "admin";
    CustomServiceCreatorRoleEnum["PARTNER"] = "partner";
})(CustomServiceCreatorRoleEnum = exports.CustomServiceCreatorRoleEnum || (exports.CustomServiceCreatorRoleEnum = {}));
let CustomService = class CustomService {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], CustomService.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        name: 'name',
        length: 255,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.Override({ length: 32768, isRichText: true }),
    (0, typeorm_1.Column)('text', {
        name: 'hints_de__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "hintsDe", void 0);
__decorate([
    data_ui_1.DataUi.Override({ length: 32768, isRichText: true }),
    (0, typeorm_1.Column)('text', {
        name: 'hints_en__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "hintsEn", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CustomService.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CustomService.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], CustomService.prototype, "deletedAt", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: CustomServiceCreatorRoleEnum,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "creatorRole", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 255,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "creatorName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "headline", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: invoicing_target_1.GeneralInvoicingTargetEnum,
        name: 'invoicing_target',
        default: invoicing_target_1.GeneralInvoicingTargetEnum.GID,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "invoicingTarget", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "pricePurchasingSum", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "priceSellingSum", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "priceListsSum", void 0);
__decorate([
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "pricePurchasing", void 0);
__decorate([
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "priceSelling", void 0);
__decorate([
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "priceLists", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('Unit_measure'),
    (0, typeorm_1.Column)('character varying', {
        name: 'measure',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "measure", void 0);
__decorate([
    (0, typeorm_1.Column)('decimal', {
        name: 'quantity',
        nullable: true,
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "quantity", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Service Type (Installation, Materialkosten)' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('service_type'),
    (0, typeorm_1.Column)('varchar', {
        name: 'service_type',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], CustomService.prototype, "serviceType", void 0);
__decorate([
    (0, typeorm_1.Column)('bigint', {
        nullable: true,
        name: 'sort_index',
    }),
    __metadata("design:type", Number)
], CustomService.prototype, "sortIndex", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => job_1.Job, (job) => job.customServices),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", job_1.Job)
], CustomService.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_selection_1.JobSelection, (selection) => selection.c_service),
    __metadata("design:type", Array)
], CustomService.prototype, "selections", void 0);
CustomService = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Custom Services',
    }),
    (0, typeorm_1.Unique)([
        'name',
        'hintsDe',
        'hintsEn',
        'invoicingTarget',
        'pricePurchasing',
        'priceSelling',
        'priceLists',
        'measure',
        'quantity',
        'job',
    ]),
    (0, typeorm_1.Entity)('custom_service', { schema: 'public' })
], CustomService);
exports.CustomService = CustomService;
//# sourceMappingURL=custom-services.js.map